<section *ngIf="bannerMessages && bannerMessages.messages && bannerMessages.messages.length && isBannerMessageVisible" aria-label="Important weather announcement">
    <ng-container *ngFor="let message of bannerMessages.messages; let i = index; trackBy: trackByIndex">
        <div *ngIf="message.display && isWeatherBannerVisible" role="alert">
            <p-message styleClass="border-none border-noround p-3 shadow-2" [severity]="message.theme"
                [icon]="message.theme !== 'success' && message.theme !== 'info' ? 'pi pi-exclamation-triangle' : ''" closable [attr.data-auto-id]="'weather-banner-' + i"
                (onClose)="handleMessageClose()"
                [ariaInjector]="[{
                    selector: '.p-message-close-button',
                    ariaLabel: 'Weather banner close button ' + (i + 1),
                    role: 'button'
                }]">
                <div [innerHTML]="message.html" class="-my-3 font-normal line-height-2"></div>
            </p-message>
        </div>
    </ng-container>
</section>